<div class="row g-1">
  <div class="col-md-12">
    <h5 class="notification-head">
      {{ 'NOTIFICATION_PAGE.NOTIFICATION_TABLE_HEADING' | translate }}
    </h5>
    <p-table
      [value]="notificationItems.length !== 0 ? notificationItems : noDataRow"
      [paginator]="notificationItems.length !== 0 ? true : false"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [lazy]="true"
      (onPage)="pageChange($event)"
      (onSort)="sortChange($event)"
      [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
      sortField="SentOn"
      [sortOrder]="-1"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="table-head" pSortableColumn="SentOn">
            {{ 'NOTIFICATION_PAGE.NOTIFICATION_TABLE.DATE' | translate }}
            <p-sortIcon field="SentOn"></p-sortIcon>
          </th>
          <th pSortableColumn="Title">
            {{ 'NOTIFICATION_PAGE.NOTIFICATION_TABLE.TITLE' | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>
          <th pSortableColumn="CountryName">
            {{ 'NOTIFICATION_PAGE.NOTIFICATION_TABLE.COUNTRY' | translate }}
            <p-sortIcon field="CountryName"></p-sortIcon>
          </th>
          <th pSortableColumn="SendTo">
            {{ 'NOTIFICATION_PAGE.NOTIFICATION_TABLE.SEND_TO' | translate }}
            <p-sortIcon field="SendTo"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notification>
        <tr
          *ngIf="notificationItems?.length !== 0"
          (click)="showNotificationPopup($event, notification.title, notification.message)"
          class="user-row"
        >
          <td>
            {{ getConvertedDateTime(notification.sentOn || '') | date: 'dd-MMM-yyyy h:mm a' }}
          </td>
          <td>{{ notification.title }}</td>
          <td>{{ notification.countryName }}</td>
          <td>{{ getNotificationRecipient(notification) }}</td>
        </tr>
        <tr *ngIf="notificationItems?.length === 0">
          <td colspan="4" class="no-data-available">
            {{ 'COMMON.NO_AVAILABLE' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div class="card flex justify-content-center gap-2">
  <p-confirmDialog>
    <ng-template pTemplate="header">
      <i class="pi pi-envelope dialog-header-icon"></i>
      <span>{{ notificationTitle }}</span>
      <i class="pi pi-times dialog-close-icon" (click)="closeConfirmDialog()"></i>
    </ng-template>
    <ng-template pTemplate="message">
      <p>{{ notificationMessage }}</p>
    </ng-template>
  </p-confirmDialog>
</div>
